import { landStoryIds, storyNavRes  } from "../../interfaces";

export const getStoryPreference = (): storyNavRes => {
    let params = new URLSearchParams(window.location.search);
    if (!params.has("story")) return checkPathForStorySub();

    let storyPref = params.get("story");
    params.delete("story");
    window.history.replaceState({}, "", (window.location.pathname + (params.toString() ? "?" + params.toString() : "")));
    const hasStory = ["aap", "acc"].includes(storyPref || "");
    return {
        storyid: (storyPref || "aap") as landStoryIds,
        hasparam: hasStory,
        haspath: false
    };
};





export const getRedeemSpaceName = () => {
    let params = new URLSearchParams(window.location.search);
    let redeemSpaceName = params.get("spt");
    return redeemSpaceName;
};

export const getRedeemToken = () => {
    let params = new URLSearchParams(window.location.search);
    let redeemCode = params.get("redeemCode");
    return redeemCode;
};

export const getTokenMail = (token: any) => {
    import.meta.env.DEV === true && console.log("‹tok›", token);
    return token.idTokenClaims?.emails?.length > 0 ? token.idTokenClaims?.emails[0] : token.idTokenClaims?.email;
};

export const getAnonToken = () => {
    let params = new URLSearchParams(window.location.search);
    let aT = params.get("A");
    return aT;
};

export const getUrlUid = () => {
    let params = new URLSearchParams(window.location.search);
    return params.get("uid") || "";
};

export const generateRandomString = (length = 10) => {
    const characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    let result = '';
    for (let i = 0; i < length; i++) {
        result += characters.charAt(Math.floor(Math.random() * characters.length));
    }
    return result;
}

export const checkPathForInfoPages = () => {
    const pathname = window.location.pathname?.toLowerCase() || '';
    const subPath = import.meta.env.VITE_INFO_SUB || "/details";
    if (pathname.startsWith(subPath)) {
        return true;
    } else {
        return false;
    }
}

export const checkPathForStorySub = ():storyNavRes => {
    let storyPref = null;

    const pathname = window.location.pathname?.toLowerCase() || '';
    const subPath = import.meta.env.VITE_INFO_SUB || "/details";
    if (pathname.startsWith(subPath)) {
        if (pathname?.includes("accounting")) {
            return {
                storyid: "acc" as landStoryIds,
                hasparam: false,
                haspath: true
            }
        } else if (pathname?.includes("callcenter")) {
            return  {
                storyid: "aap" as landStoryIds,
                hasparam: false,
                haspath: false
            };
        } else {
            return {
                storyid: "aap" as landStoryIds,
                hasparam: false,
                haspath: false
            };
        }
    } else {
        return {
            storyid: "aap" as landStoryIds,
            hasparam: false,
            haspath: false
        }
    }
}
